import api from "./../../config/axiosInstance";

const authUserOnCompany = async (user, companyId) => {
  return await api
    .dillApi()
    .post("/security/auth", { userId: user.id, companyId });
};

export default authUserOnCompany;
